import React from 'react'

const SvgComponent = ({ svgRef, ...props }) => (
  <svg viewBox="0 0 763.802 181.786" ref={svgRef} {...props}>
    <title>
      Generic postal mail and email illustrations
    </title>
    <defs>
      <style>
        {`.cls-1{fill:#d9d9d6}.cls-2{fill:#f2f2f2}.cls-3{fill:#0061a0}.cls-4{fill:#0090da}.cls-5{fill:#a4ce4c}.cls-9{fill:#a7a8aa}.cls-10{fill:#0062a1}`}
      </style>
      <clipPath id="monitor-screen-clip-path">
        <rect x="-47" y="-21" width="214" height="121" />
      </clipPath>
      <clipPath id="cursor-clip-path">
        <rect x="15" y="15" width="214" height="121" />
      </clipPath>
    </defs>
    <g
      id="Group_1499"
      data-name="Group 1499"
      transform="translate(-360 -470.114)"
    >
      <g
        id="mailbox-wrapper"
        data-name="Group 727"
        transform="translate(894.375 498.5)"
      >
        <g id="mailbox">
        <g
            id="letter-in-the-mailbox"
            data-name="Group 724"
            transform="translate(19.119 76.476)"
          >
            <path
              id="Rectangle_330"
              data-name="Rectangle 330"
              className="cls-1"
              d="M0 0h109.285v63.73H0z"
            />
            <path
              id="Path_245"
              data-name="Path 245"
              className="cls-2"
              d="M8.1 32.4l54.524 41.07 54.76-41.07z"
              transform="translate(-8.1 -32.4)"
            />
          </g>
          <g
            id="mailbox-door"
            data-name="Group 725"
            transform="translate(0 140.205)"
          >
            <path 
              id="Union_1" 
              data-name="Union 1" 
              className="cls-3" 
              d="M16002.625-4528.64v-12.745h82.85v6.37H16009v6.375Z" 
              transform="translate(-16002.625 4541.384)"
            />
          </g>
          <path
            id="Path_246"
            data-name="Path 246"
            className="cls-4"
            d="M53.983 21.6h108.576a18.938 18.938 0 0 1 18.883 18.883v57.593a18.938 18.938 0 0 1-18.883 18.883H53.983A18.938 18.938 0 0 1 35.1 98.076V40.483A18.938 18.938 0 0 1 53.983 21.6z"
            transform="translate(47.749 29.384)"
          />
          <path
            id="Rectangle_333"
            data-name="Rectangle 333"
            className="cls-4"
            transform="translate(82.849 50.984)"
            d="M0 0h101.968v95.595H0z"
          />
          <path
            id="Rectangle_334"
            data-name="Rectangle 334"
            className="cls-4"
            transform="translate(82.849 95.595)"
            d="M0 0h146.578v50.984H0z"
          />
          <g id="mailbox-flag">
            <path
              id="Path_247"
              data-name="Path 247"
              className="cls-5"
              d="M114.248 31.865H63.5V3.3A3.34 3.34 0 0 1 66.568 0h47.679a3.18 3.18 0 0 1 3.068 3.3v25.5a3.124 3.124 0 0 1-3.067 3.065z"
              transform="translate(86.383)"
            />
            <path
              id="Rectangle_335"
              data-name="Rectangle 335"
              className="cls-5"
              transform="translate(149.883)"
              d="M0 0h12.746v98.663H0z"
            />
            <path
              id="Path_248"
              data-name="Path 248"
              className="cls-5"
              d="M69.873 51.846a6.346 6.346 0 0 1-6.373-6.373 6.346 6.346 0 0 1 6.373-6.373 6.346 6.346 0 0 1 6.373 6.373 6.667 6.667 0 0 1-6.373 6.373z"
              transform="translate(86.383 53.19)"
            />
            <path
              id="Path_249"
              data-name="Path 249"
              d="M67.968 46.737a3.124 3.124 0 0 1-3.068-3.069 3.124 3.124 0 0 1 3.068-3.068 3.124 3.124 0 0 1 3.068 3.068 3.124 3.124 0 0 1-3.068 3.069z"
              transform="translate(88.287 55.231)"
              fill="#ffc600"
            />
          </g>
        </g>
      </g>
      <g
        id="monitor"
        data-name="Group 941"
        transform="translate(599 470.859)"
      >
        <g id="Group_939" data-name="Group 939">
          <path
            id="Path_304"
            data-name="Path 304"
            className="cls-4"
            d="M226.239 150.991H15.149A15.209 15.209 0 0 1 0 135.843V15.149A15.051 15.051 0 0 1 15.149 0h211.338a15.051 15.051 0 0 1 15.149 15.149v120.694a15.592 15.592 0 0 1-15.397 15.148z"
          />
          <path
            id="Rectangle_431"
            data-name="Rectangle 431"
            transform="translate(15.149 15.149)"
            fill="#fff"
            d="M0 0h211.338v120.694H0z"
          />
          <path
            id="Rectangle_432"
            data-name="Rectangle 432"
            className="cls-4"
            transform="translate(60.347 165.892)"
            d="M0 0h120.694v15.149H0z"
          />
          <g
            id="Group_938"
            data-name="Group 938"
            transform="translate(75.496 150.743)"
          >
            <path
              id="Path_305"
              data-name="Path 305"
              className="cls-3"
              d="M105.9 60.7H45.549A15.051 15.051 0 0 1 30.4 75.849h90.644A15.051 15.051 0 0 1 105.9 60.7z"
              transform="translate(-30.4 -60.7)"
            />
          </g>
        </g>
        <path
          id="Path_306"
          data-name="Path 306"
          className="cls-2"
          d="M184.7 6.1h-36.006L28 126.794h156.7z"
          transform="translate(41.535 9.049)"
        />
        <g
          id="Group 940"
          data-name="Group 940"
          transform="translate(62.582 35.264)"
          clipPath="url(#monitor-screen-clip-path)"
        >
          <g id="envelope">
            <path
              id="Rectangle_433"
              data-name="Rectangle 433"
              className="cls-1"
              d="M0 0h115.975v67.549H0z"
            />
            <path
              id="Path_307"
              data-name="Path 307"
              className="cls-2"
              d="M25.2 14.2l58.112 43.46 58.112-43.46z"
              transform="translate(-25.2 -14.2)"
            />
          </g>
        </g>
        <g clipPath="url(#cursor-clip-path)">          
          <path
            id="cursor"
            data-name="Path 308"
            d="M103.351 57.2L66.1 27.9v43.46l11.672-7.7 10.182 20.613 10.43-5.215-10.43-19.122z"
            transform="translate(98.053 41.387)"
            fill="#a4ce4e"
          />
        </g>
        
      </g>
      <g
        id="gray-paper"
        data-name="Group 1075"
        transform="translate(360 470.114)"
      >
        <path
          id="Path_313"
          data-name="Path 313"
          className="cls-2"
          d="M0 35.088v146.326h135.874V0H35.088z"
        />
        <path
          id="Path_314"
          data-name="Path 314"
          className="cls-1"
          d="M35.462 0v35.462H0z"
        />
        <path
          id="Rectangle_444"
          data-name="Rectangle 444"
          className="cls-9 gray-text"
          transform="translate(25.383 67.937)"
          d="M0 0h85.108v5.599H0z"
        />
        <path
          id="Rectangle_445"
          data-name="Rectangle 445"
          className="cls-9 gray-text"
          transform="translate(25.383 85.108)"
          d="M0 0h85.108v5.599H0z"
        />
        <path
          id="Rectangle_446"
          data-name="Rectangle 446"
          className="cls-9 gray-text"
          transform="translate(25.383 51.139)"
          d="M0 0h85.108v5.599H0z"
        />
        <path
          id="Rectangle_447"
          data-name="Rectangle 447"
          className="cls-9 gray-text"
          transform="translate(25.383 101.905)"
          d="M0 0h85.108v5.599H0z"
        />
        <path
          id="Rectangle_448"
          data-name="Rectangle 448"
          className="cls-9 gray-text"
          transform="translate(25.383 119.076)"
          d="M0 0h85.108v5.599H0z"
        />
        <path
          id="Rectangle_449"
          data-name="Rectangle 449"
          className="cls-9 gray-text"
          transform="translate(25.383 136.247)"
          d="M0 0h39.568v5.599H0z"
        />
        <g id="blue-pencil">
          <path
            id="Path_316"
            data-name="Path 316"
            className="cls-10"
            d="M27.562 44.711c-.747.747-4.106 3.36-4.853 2.986-.747-.747 1.493-4.106 2.613-5.226.747-.747 2.24-1.12 2.613-.373.747.373.373 1.493-.373 2.613"
            transform="translate(61.652 113.933)"
          />
          <path
            id="Path_317"
            data-name="Path 317"
            d="M108.308 16.7c-9.708 5.226-27.25 20.53-45.914 40.314-22.77 24.263-38.821 46.66-39.194 53.752l2.24 2.24c7.092-.747 28.369-18.291 51.139-42.181 18.664-19.784 32.849-38.074 37.328-48.153z"
            transform="translate(63.401 45.638)"
            fill="#218ece"
          />
          <path
            id="Path_318"
            data-name="Path 318"
            className="cls-10"
            d="M49.611 62.613c14.931-16.424 25.757-31.355 29.863-39.941l-5.6-5.972c-8.212 4.479-22.4 16.424-38.074 32.475z"
            transform="translate(97.834 45.638)"
          />
          <path
            id="Rectangle_450"
            data-name="Rectangle 450"
            className="cls-1"
            transform="rotate(-46.74 187.309 -104.795)"
            d="M0 0h40.687v4.853H0z"
          />
          <path
            id="Rectangle_451"
            data-name="Rectangle 451"
            transform="rotate(-46.74 159.91 -168.086)"
            fill="#a4ce4d"
            d="M0 0h5.972v4.853H0z"
          />
        </g>
      </g>
    </g>
  </svg>
)

const SubmitDocumentationSVG = React.forwardRef((props, ref) => (
  <SvgComponent svgRef={ref} {...props} />
))

export default SubmitDocumentationSVG
